export const formatSeconds = (value?: number) => {
  if (value == null) {
    return value
  }

  let min = Math.floor(value / 60).toString()
  let sec = (value % 60).toFixed(0)

  if (sec.length < 2) {
    sec = `0${sec}`
  }

  if (min.length < 2) {
    min = `0${min}`
  }

  return `${min}:${sec}`
}
